import React from "react";
import { Counter } from "./features/counter/Counter";
import { Cats } from "./features/cats/Cats";
import "./App.css";

function App() {
	return (
		<div className="App">
			<header className="App-header">
				<h1 style={{ color: "#f0f0f0" }}>Redux List</h1>

				<Counter />
				<Cats />
			</header>
		</div>
	);
}

export default App;
